import { render, staticRenderFns } from "./InputOtp.vue?vue&type=template&id=65a2890d&scoped=true"
import script from "./InputOtp.vue?vue&type=script&lang=js"
export * from "./InputOtp.vue?vue&type=script&lang=js"
import style0 from "./InputOtp.vue?vue&type=style&index=0&id=65a2890d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2890d",
  null
  
)

export default component.exports